<template>
  <ResponsiveLayout
    sticky-actions
    :show-kaia-logo="false"
    :show-lang-picker="false"
    theme="blue-background"
  >
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper self-test-reevaluations-complete">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge kds-typography-center"
          v-html="$t('b2b_self_test_reevaluations_complete_header')"
        />
        <div
          class="kds-typography-paragraph-large kds-typography-center"
          v-html="$t('b2b_self_test_reevaluations_complete_description')"
        />
      </div>
      <div class="self-test-reevaluations-complete__background" />
    </div>
    <template #actions>
      <BaseButton
        :loading="isLoading"
        :text="$t('b2b_self_test_reevaluations_complete_cta')"
        data-qa="submit"
        variant="outlined"
        @click="next"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestReevaluationStore from '@shared/modules/assessment/stores/useSelfTestReevaluationStore.js'
import BaseButton from '@shared/components/BaseButton.vue'
import Tracker from '@shared/Tracker'
import { computed, ref } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import * as apiRequest from '@shared/api-endpoints'

const reevaluationsStore = useSelfTestReevaluationStore()

const props = defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const isLoading = ref(false)

const selfTestReevaluationsAnswers = computed(
  () => reevaluationsStore.selfTestReevaluationsAnswers,
)

const next = async () => {
  isLoading.value = true

  try {
    await apiRequest.submitSelfTestReevaluations(
      selfTestReevaluationsAnswers.value,
    )

    Tracker.trackKaiaEvent(
      {
        event_name: 'c.lfcycl.submit_monthly_checkup',
        action: 'submit',
        object_type: 'initial_assessment',
        screen_name: 'onb_finish_congratulations',
      },
      selfTestReevaluationsAnswers.value,
    )
  } catch (error) {
    console.warn(error)
  }

  props.handleNextEvent()
}
</script>

<style lang="scss" scoped>
.self-test-reevaluations-complete {
  background: url('@shared/assets/img/commitment-intro-background_fireworks.svg')
    center 86px no-repeat;
  background-size: 75%;

  &__background {
    height: 200px;
    margin-top: 32px;
    margin-bottom: -1px;
    background: url('@shared/assets/img/commitment-intro-background_people.svg')
      center bottom no-repeat;
    background-size: contain;
  }
}
</style>
